import { Controller } from "@hotwired/stimulus"

export default class PercentFieldController extends Controller {
  static targets = ["input", "hiddenInput"]

  update() {
    if (this.inputTarget.value == "") {
      this.hiddenInputTarget.value = this.inputTarget.value
    } else {
      this.hiddenInputTarget.value = this.inputTarget.value / 100
    }
    this.hiddenInputTarget.dispatchEvent(new Event("change"))
  }
}
